<template>
  <div class="multiple-buttons" v-if="isActive">
    <siema
      :options="{perPage: 2.5}"
      @update:current="changeSlice"
      ref="quick_reply">
      <div v-for="(quickReply, index) in quickReplies" :key="index" class="button-single" @click="reply(quickReply.title)" :title="quickReply.title">{{quickReply.title}}</div>
    </siema>
    <div v-if="quickReplies.length > 1">
      <button :class="{disabled: currentSlide === 0}" @click="$refs.quick_reply.prev()"><v-icon name="chevron-left" scale="1" fill="#8C8C8C"/></button>
      <button :class="{disabled: currentSlide >= quickReplies.length - 2}" @click="$refs.quick_reply.next()"><v-icon name="chevron-right" scale="1" fill="#8C8C8C"/></button>
    </div>
  </div>
</template>

<script>
import { Siema } from 'vue2-siema'
import eventHub from '../lib/hub'
import { mapState } from 'vuex'

const objectPath = require('object-path')
const _last = require('lodash/last')
export default {
  name: 'RepliesButton',
  props: ['quickReplies', 'eventId', 'convoId'],
  data () {
    return {
      currentSlide: 0
    }
  },

  computed: {
    ...mapState([
      'convoEvents'
    ]),

    isActive () {
      let eventsByConvo = this.convoEvents[this.convoId] || []
      let messageByUser = eventsByConvo.filter(e => e.type === 'message_sent' && e.by.type === 'user')
      let eventHasQuickReply = eventsByConvo.find(e => e.id === this.eventId)
      let lastEvent = _last(messageByUser)
      if (!lastEvent || eventHasQuickReply.created > lastEvent.created) return true
      return false
    }
  },

  watch: {
    quickReplies () {
      if (this.$refs.quick_reply) this.$refs.quick_reply.destroy(true, this.$refs.quick_reply.init())
    }
  },

  components: {
    Siema
  },

  methods: {
    reply (text) {
      if (!text.trim()) return false
      eventHub.$emit('quick_replies', text)
    },

    changeSlice (number) {
      this.currentSlide = number
    }
  }
}
</script>
